import React from "react";
import { Request } from "../../hooks/Request";
import useSize from "../../hooks/useSize";
import Table from "./Table";
import { Button } from "../Buttons";
import TableComplete from "./TableComplete";
import Pagination from "./Pagination";
import { useState, useEffect } from "react";
import Search from "./SearchTable";
import { validateArray } from "../../utils/validate";
import { viewLinkExcel } from "../../utils/constGenerate";
import { requestAuth } from "../services/RequestService";
import { toast } from "react-toastify";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import { H3 } from "../Text";

const CallServiceTable = (props) => {
  const {
    urlApi,
    header,
    addUrl,
    onClick = () => { },
    filters,
    addFilters = [],
    reload,
    component: Component,
    responsive,
    downloadUrl = "",
    download = false,
    aditionalParams = {},
    indexSelectedRef,
    reloaders = []
  } = props;

  const { openDialog, dialogClose } = useDialog();
  const [target, currentSize] = useSize();
  const [pageNumber, setPageNumber] = useState(1);
  const [selected, setSelected] = useState(handleInitialSelected());
  function handleInitialSelected() {
    const list = [...addFilters, ...header].filter((item) => item.filter);
    if (validateArray(list)) {
      return list[0].name;
    }
    return "";
  }
  const [search, setSearch] = useState("");

  const [tableComplete, setTableComplete] = useState(true);

  const [params, setParams] = useState(() => {
    let paramsInitial = {};
    if (filters && validateArray(filters)) {
      filters.forEach((element) => {
        if (validateArray(element.options)) {
          const optionsInitial = element.options.filter((item) => item.initial);
          if (optionsInitial && validateArray(optionsInitial)) {
            paramsInitial = {
              ...paramsInitial,
              [element.name]: optionsInitial[0].name,
            };
          }
        }
        if (element.defRefValue) {
          paramsInitial = {
            ...paramsInitial,
            [element.name]: element.defRefValue,
          };

        }
      });
    }
    return paramsInitial;
  });

  const { data, loading, pagination, call, error, buttons } = Request({
    urlApi: urlApi
      ? `${urlApi}?PageNumber=${pageNumber}${addUrl ? `&${addUrl}` : ""}${selected !== "" && search !== ""
        ? `&ForQuery=${selected}&TypeQuery=${search}`
        : ""
      }${handleFilters(params)}`
      : null,
    params: aditionalParams
  });

  function handleFilters(filters) {
    let aux = "";
    if (filters) {
      for (let key in filters) {
        if (filters[key]) {
          aux = aux + `&${key}=${filters[key]}`;
        }
      }
    }
    return aux;
  }

  // async function handleDownload2() {
  //   await requestAuth(
  //     "post",
  //     urlApi
  //       ? `${downloadUrl ? downloadUrl : urlApi}?PageNumber=${pageNumber}${addUrl ? `&${addUrl}` : ""
  //       }${selected !== "" && search !== ""
  //         ? `&ForQuery=${selected}&TypeQuery=${search}`
  //         : ""
  //       }${handleFilters(params)}`
  //       : null,
  //     null,
  //     aditionalParams
  //   )
  //     .then((resp) => {
  //       viewLinkExcel(resp.data, openDialog);
  //       toast.success("Registro exitoso");
  //     })
  //     .catch(() => {
  //       toast.error("Se produjo un error al guardar");
  //     });
  // }

  async function handleDownload() {
    openDialog(
      <DialogConfirmation
        children={
          <H3>¿Estas seguro que quieres generar el reporte de archivo?</H3>
        }
        onClose={dialogClose}
        method="post"
        url={urlApi
          ? `${downloadUrl ? downloadUrl : urlApi}?PageNumber=${pageNumber}${addUrl ? `&${addUrl}` : ""
          }${selected !== "" && search !== ""
            ? `&ForQuery=${selected}&TypeQuery=${search}`
            : ""
          }${handleFilters(params)}`
          : null}
        texBtn="Generar"
        handleSuccess={(a) => viewLinkExcel(a, openDialog)}
      />
    );
  }

  useEffect(() => {
    if (loading) {
      call();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlApi, pageNumber, ...reloaders]);

  useEffect(() => {
    if (loading) {
      setPageNumber(1);
      call();
    }
  }, [reload, params]);

  // useEffect(() => {
  //   if (loading) {
  //     setPageNumber(1);
  //     call();
  //   }
  // }, [reload, params, search]);

  return (
    <div className="flex flex-col h-full">
      {error ? (
        <div className="flex flex-col items-center justify-center p-6 bg-red-50 border border-red-200 rounded-2xl shadow-sm">
          <div className="text-red-500 text-4xl mb-2">⚠️</div>

          <h2 className="text-lg font-semibold text-red-700">
            Error al cargar datos
          </h2>

          <p className="text-sm text-red-600 mt-1 text-center">
            No se pudo cargar la información. Intenta nuevamente.
          </p>

          <button
            onClick={() => call()}
            className="mt-4 px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition"
          >
            Reintentar
          </button>
        </div>
      ) : (
        <>
          <div className="flex mb-2 justify-between portrait:flex-col-reverse gap-2 portrait:items-end">
            <Search
              setSelected={setSelected}
              setSearch={setSearch}
              search={search}
              header={header}
              filters={filters}
              params={params}
              setParams={setParams}
              reload={call}
              addFilters={addFilters}
              setPageNumber={setPageNumber}
            />
            <div className="flex items-center gap-2">
              {Component && <Component {...props} reload={call} />}
              {download && (
                <Button
                  onClick={handleDownload}
                  width="w-auto"
                  content="Descargar información en Excel"
                  className="py-3 text-lg"
                >
                  <i className="fas fa-file-download"></i>
                </Button>
              )}
              {/* <Button
                onClick={() => setTableComplete(!tableComplete)}
                width="w-auto"
                className="py-3 text-lg"
              >
                <i className="fas fa-exchange-alt"></i>
              </Button> */}
            </div>
          </div>
          {/* <br /> */}
          <div
            ref={target}
          // style={{ maxHeight: pagination ? "calc(100% - 120px)" : "98%" }}
          >
            {currentSize && (currentSize.height || currentSize.height === 0) ? (
              loading ? (
                <>
                  {tableComplete ? (
                    <TableComplete
                      header={header}
                      data={data}
                      call={call}
                      height={currentSize.height ? currentSize.height : null}
                      onClick={onClick}
                      buttons={buttons}
                      indexSelectedRef={indexSelectedRef}
                    />
                  ) : (
                    <Table
                      call={call}
                      onClick={onClick}
                      data={data}
                      header={header}
                      responsive={responsive}
                    />
                  )}
                </>
              ) : null
            ) : null}
          </div>
          {pagination && (
            <Pagination
              pag={pagination ? JSON.parse(pagination) : null}
              setPageNumber={setPageNumber}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CallServiceTable;
